type Feature = {
  id: number
  name: string
  value: number
}

type PlanLimitsCardType = {
  usage: {
    id: number
    title: string
    isFeatured?: boolean
    features?: Array<Feature>
  }
}

const PlanLimitsCard = ({
  usage: { title, isFeatured, features },
}: PlanLimitsCardType) => {
  // @@TODO: Test isFeatured layout.
  const className = `${
    isFeatured ? 'bg-gray-200' : 'bg-gray-100'
  } bg-gray-50 dark:bg-gray-900 border-top border-bottom px-4 px-lg-0 md:col-span-1`
  const className2 = ''

  return (
    <div>
      <div
        className={`${className2} h-6 min-w-19 bg-yellow-400 font-semibold text-end`}
      >
        {title}
      </div>
      <div>
        <pre>
          <code className="font-mono">
            {features?.map((feature) => (
              <div
                className="h-6 font-extralight text-base items-center text-end"
                key={feature.id}
              >
                {feature.value}
              </div>
            ))}
          </code>
        </pre>
      </div>
    </div>
  )
}

export default PlanLimitsCard
